import { filtersHelper } from '@/utils';
import { countryModel } from '@/models/api/country.model';
import { stateModel } from '@/models/api/state.model';

export const locationModel = (data) => ({
    uuid: data.uuid,
    name: data.name,
    displayName: data.display_name,
    addrLine1: data.addr_line_1,
    addrLine2: data.addr_line_2,
    addrLine3: data.addr_line_3,
    city: data.city,
    postcode: data.postcode,
    googleMapLink: data.google_map_link,
    lat: data.lat,
    lng: data.lng,
    isActive: data.is_active,
    createdAt: filtersHelper.getDateFormat(data.created_at),
    createdBy: data.created_by,
    updatedAt: filtersHelper.getDateFormat(data.updated_at),
    updatedBy: data.updated_by,
    deletedAt: filtersHelper.getDateFormat(data.deleted_at),
    deletedBy: data.deleted_by,
    state: data.state ? stateModel(data.state) : null,
    country: data.country ? countryModel(data.country) : null
});